"use strict";
var _IrrigationSequentialSchedule_instances, _IrrigationSequentialSchedule_joinRuns, _IrrigationSequentialSchedule_calculateTimeDifferent;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrrigationSequentialSchedule = void 0;
const tslib_1 = require("tslib");
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
const duration_1 = tslib_1.__importDefault(require("dayjs/plugin/duration"));
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
const typeName = 'IrrigationSequentialSchedule';
const MINUTES_IN_DAY = 24 * 60; //1440
class IrrigationSequentialSchedule extends datamodel_core_1.ModelCommon {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f;
        super(ob.type || typeName, ob);
        _IrrigationSequentialSchedule_instances.add(this);
        _IrrigationSequentialSchedule_calculateTimeDifferent.set(this, (start, end) => {
            let diff = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(start, (0, datamodel_core_1.getModifedTime)(end, 0, 'add'));
            return Math.min(MINUTES_IN_DAY, diff);
        });
        this.getHash = () => (0, iotv_v3_types_1.getObjectHash)(this);
        this.name = (_a = ob.name) !== null && _a !== void 0 ? _a : '';
        this.active = (_b = ob.active) !== null && _b !== void 0 ? _b : false;
        this.dayMask = (_c = ob.dayMask) !== null && _c !== void 0 ? _c : [];
        this.cycles = (_d = ob.cycles) !== null && _d !== void 0 ? _d : [(0, DefinitionAndHelpers_1.generateDefaultCycle)(this.dayMask, 0)];
        this.valves = (_e = ob.valves) !== null && _e !== void 0 ? _e : [];
        this.zones = (_f = ob.zones) !== null && _f !== void 0 ? _f : [];
        this.updated_at = ob.updated_at;
        // this.tz = ob.tz ?? Intl.DateTimeFormat().resolvedOptions().timeZone
    }
    // tz: string
    // specificDayMask: number[][]
    /** Simple getters */
    getCycleSize() {
        return this.cycles.length;
    }
    getZoneSize() {
        return this.zones.length;
    }
    getRollover(cycle) {
        let rolloverSet = Array(this.getZoneSize()).fill(false);
        let relevantCycle = this.cycles[cycle];
        const startTime = relevantCycle.start_time;
        const endTime = relevantCycle.start_time.map((time, i) => (0, DefinitionAndHelpers_1.getEndTime)(time, relevantCycle.duration[i]));
        startTime.forEach((start, i) => {
            const previous = i - 1;
            if (i > 0) {
                if (start === endTime[previous]) {
                    if (rolloverSet[previous] === true || startTime[previous].localeCompare(start) === 1) {
                        rolloverSet[i] = true;
                    }
                }
            }
        });
        return rolloverSet;
    }
    getZoneDuration(index) {
        return this.cycles
            .map((cycle) => {
            var _a;
            const dayMaskCount = ((_a = cycle.dayMask) !== null && _a !== void 0 ? _a : this.dayMask).length;
            const cycleDuration = cycle.duration[index];
            return dayMaskCount * cycleDuration;
        })
            .reduce((acc, cur) => {
            acc += cur;
            return acc;
        }, 0);
    }
    getZonesRollover(index) {
        return this.cycles.map((_, i) => {
            return this.getCyclesRollover(i, index);
        });
    }
    getCyclesRollover(cycle, index) {
        const all = this.getRollover(cycle);
        return all[index];
    }
    /**Simple Setters */
    setName(newName) {
        this.name = newName;
    }
    setCycleCount(newCount) {
        if (this.getCycleSize() < newCount) {
            // add new
            // const newCycle = generateDefaultCycle(this.dayMask, this.zones.length)
            let updatedCycle = [...this.cycles];
            while (updatedCycle.length < newCount) {
                updatedCycle.push((0, DefinitionAndHelpers_1.generateDefaultCycle)(this.dayMask, this.zones.length));
            }
            this.cycles = updatedCycle;
        }
        else {
            // trim cycle count
            this.cycles = this.cycles.slice(0, newCount);
        }
    }
    setZones(groupIDS) {
        this.zones = groupIDS;
        const groupsLength = groupIDS.length;
        let updatedCycles = this.cycles.map((cycle) => {
            var _a;
            let updatedDuration = cycle.duration.slice(0, groupsLength);
            let updatedStartTime = cycle.start_time.slice(0, groupsLength);
            while (updatedDuration.length < this.zones.length) {
                updatedStartTime.push((0, DefinitionAndHelpers_1.getEndTime)(updatedStartTime.at(-1), (_a = updatedDuration.at(-1)) !== null && _a !== void 0 ? _a : 0));
                updatedDuration.push(1);
                // updatedStartTime.push('00:00')
            }
            return {
                dayMask: cycle.dayMask,
                duration: updatedDuration,
                start_time: updatedStartTime,
            };
        });
        this.cycles = updatedCycles;
        // update cycles with default, if required
    }
    setDayMask(dayMask, specific) {
        if (specific === undefined) {
            this.dayMask = dayMask;
            let copyMask = [...this.cycles];
            copyMask = copyMask.map((specific) => {
                return { ...specific, dayMask };
            });
            this.cycles = copyMask;
        }
        else {
            let copyMask = [...this.cycles];
            copyMask[specific].dayMask = dayMask;
            this.cycles = copyMask;
        }
    }
    setMasterValve(valveIDS) {
        this.valves = valveIDS;
    }
    setUpdateTime(cycle, index, ifSameDur, ifTimeFlow, durationLimit, duration, startTime, volume = false) {
        let cyclesCopy = [...this.cycles];
        const zoneSize = this.getZoneSize();
        if (volume) {
        }
        else {
            if (duration) {
                const durationFromZero = Math.min(Math.max(0, duration), DefinitionAndHelpers_1.MVC_DURATION_LIMIT);
                // const irrGroupDuration = Math.min(Math.max(0, duration), IRR_DURATION_LIMIT);
                // const mvcDuration = Math.min(Math.max(0, duration), MVC_DURATION_LIMIT);
                if (ifSameDur) {
                    const grouplength = cyclesCopy[cycle].start_time.length;
                    const durationResult = Array(grouplength)
                        .fill(durationFromZero)
                        .map((val, i) => {
                        return Math.min(val, durationLimit[i]);
                    });
                    cyclesCopy[cycle].duration = durationResult;
                }
                else {
                    cyclesCopy[cycle].duration[index] = Math.min(durationFromZero, durationLimit[index]);
                }
            }
            else if (startTime) {
                cyclesCopy[cycle].start_time[index] = startTime;
            }
        }
        if (ifTimeFlow) {
            let last = cyclesCopy[cycle].start_time[index];
            let lastDuration = cyclesCopy[cycle].duration[index];
            for (let i = cycle; i < this.getCycleSize(); i++) {
                for (let zoneIndex = 0; zoneIndex < zoneSize; zoneIndex++) {
                    if (i > cycle || zoneIndex > index) {
                        last = (0, DefinitionAndHelpers_1.getEndTime)(last, lastDuration);
                        cyclesCopy[i].start_time[zoneIndex] = last;
                        lastDuration = cyclesCopy[i].duration[zoneIndex];
                    }
                }
            }
        }
        this.cycles = cyclesCopy;
        // if (ifTimeFlow) {
        //   for (let i = index + 1; i < zoneSize; i++) {
        //     console.log('WAH index', index)
        //     cyclesCopy[cycle].start_time[i] = getEndTime(cyclesCopy[cycle].start_time[i - 1], cyclesCopy[cycle].duration[i - 1])
        //   }
        // }
        // if (ifTimeFlow && cycle < this.getCycleSize() - 1) {
        //   for (let i = cycle + 1; i < this.getCycleSize(); i++) {
        //     console.log('WAH cycle', cycle)
        //     for (let j = 0; j < zoneSize; j++) {
        //       const time =
        //         j === 0
        //           ? getEndTime(cyclesCopy[i - 1].start_time[zoneSize - 1], cyclesCopy[i - 1].duration[zoneSize - 1])
        //           : getEndTime(cyclesCopy[i].start_time[j - 1], cyclesCopy[i].duration[j - 1])
        //       cyclesCopy[i].start_time[j] = time
        //     }
        //   }
        //   this.cycles = cyclesCopy
        // } else {
        //   this.cycles[cycle] = cyclesCopy[cycle]
        // }
    }
    /**
     *
     * V1 no unique downlinks
     * v2 no merging downlinks
     * v3 merging when possible? otherwise, not
     *
     * Currently, Has V1, trying v2
     */
    getMVCCycleProgramme(showAP = true) {
        var _a;
        let cycles = [];
        let zonesUsed = ((_a = this.zones) !== null && _a !== void 0 ? _a : []).length;
        // let delay = this.mvcDelay ?? 0
        try {
            if (this.cycles && zonesUsed !== 0) {
                cycles = this.cycles.map((val) => {
                    // set start durations
                    var _a;
                    const last = val.start_time.length - 1;
                    let mvcStartTime = (0, datamodel_core_1.getModifedTime)(val.start_time[0], 0, 'add');
                    let programmeFinishTime = (0, datamodel_core_1.getModifedTime)(val.start_time[last], val.duration[last], 'add');
                    let duration = 0;
                    if (zonesUsed === 1) {
                        duration = val.duration[0]; // - delay
                    }
                    else {
                        let diff = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(mvcStartTime, programmeFinishTime);
                        duration = diff;
                    }
                    // duration -= delay // not x2 as the `firstTime` has already been shifted
                    duration = Math.min(MINUTES_IN_DAY, duration); // in case the duration is for the entire day
                    return {
                        start_time: [(0, datamodel_core_1.formatDayJS)(mvcStartTime, showAP)],
                        duration: [duration],
                        dayMask: (_a = val.dayMask) !== null && _a !== void 0 ? _a : this.dayMask,
                    };
                });
            }
            // const dayMaskMapper = this.cycles.map((val) => val.dayMask ?? this.dayMask)
            let res = tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_instances, "m", _IrrigationSequentialSchedule_joinRuns).call(this, cycles);
            return res;
        }
        catch (e) {
            console.log('Missing data in MVCCycle');
            return null;
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            Name: {
                type: 'RelatedType',
                editable: false,
                label: 'Name',
                name: 'Name',
                description: 'Name of schedule eg Westerly',
                objectTypeId: 'User',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'Irrigation_Sequential_Programme_has_Name_User',
            },
            timeCreated: {
                type: 'Number',
                editable: true,
                label: 'Time Created',
                name: 'timeCreated',
                description: 'Date and time schedule was created',
            },
            startTime: {
                type: 'String',
                editable: true,
                label: 'Start Time',
                name: 'startTime',
                description: 'When the first programme starts',
            },
            userCreated: {
                type: 'String',
                editable: true,
                label: 'User Created ',
                name: 'userCreated',
                description: 'User that created schedule',
            },
            areaCovered: {
                type: 'Number',
                editable: true,
                label: 'Area covered',
                name: 'areaCovered',
                description: 'Aggregate of area covered by irrigation ',
            },
            waterApplied: {
                type: 'Number',
                editable: true,
                label: 'Water applied',
                name: 'waterApplied',
                description: 'Calculated amount of water to be applied at x pressure for y duration',
            },
            irrigationCycle: {
                type: 'Number',
                editable: true,
                label: 'Irrigation Cycle Amount',
                name: 'irrigationCycle',
                description: 'The number of programme cycles',
            },
            dayMask: {
                type: 'Enum',
                editable: true,
                label: 'Day Mask Selection',
                name: 'dayMask',
                description: 'When the programme should run (local)',
            },
        };
    }
}
exports.IrrigationSequentialSchedule = IrrigationSequentialSchedule;
_IrrigationSequentialSchedule_calculateTimeDifferent = new WeakMap(), _IrrigationSequentialSchedule_instances = new WeakSet(), _IrrigationSequentialSchedule_joinRuns = function _IrrigationSequentialSchedule_joinRuns(programme) {
    const mergedCycles = programme;
    const startEndArray = mergedCycles
        .map((val) => {
        var _a;
        if (val.start_time.at(-1) && val.duration.at(-1)) {
            return {
                start: val.start_time[0],
                end: (0, datamodel_core_1.formatDayJS)((0, datamodel_core_1.getModifedTime)(val.start_time.at(-1), val.duration.at(-1), 'add')),
                dayMask: (_a = val.dayMask) !== null && _a !== void 0 ? _a : this.dayMask,
            };
        }
    })
        .filter((val) => val !== undefined);
    const linkChecker = startEndArray.map((val, i) => {
        if (i === 0) {
            return false;
        }
        // if start is the same as the last end
        const sameStartEnd = val.start == startEndArray[i - 1].end;
        // if on the same 24hours, same day mask pattern, or if next 24 hour day, day mask shift of one
        // last start time is earlier than this start time  && day mask is the same
        const sameDaySameDaymask = JSON.stringify(startEndArray[i - 1].dayMask) === JSON.stringify(val.dayMask) && startEndArray[i - 1].start.localeCompare(val.start) === -1;
        const differentDayShiftedMask = JSON.stringify(startEndArray[i - 1].dayMask) === JSON.stringify((0, DefinitionAndHelpers_1.dayShift)(val.dayMask, 'UP')) &&
            startEndArray[i - 1].start.localeCompare(val.start) !== -1;
        return sameStartEnd && (sameDaySameDaymask || differentDayShiftedMask);
    });
    const linkRes = [];
    let cachedStart;
    let cachedEnd;
    let cachedDaymask;
    for (let i = 0; i < linkChecker.length; i++) {
        let specific = startEndArray[i];
        if (linkChecker[i] === false || cachedStart === undefined) {
            cachedStart = (0, datamodel_core_1.getModifedTime)(specific.start, 0, 'add');
            cachedEnd = specific.end;
            cachedDaymask = specific.dayMask;
        }
        else {
            cachedEnd = specific.end;
        }
        if (cachedDaymask && (i === linkChecker.length - 1 || linkChecker[i + 1] === false)) {
            // the end, generate the duration
            linkRes.push({ start_time: [(0, datamodel_core_1.formatDayJS)(cachedStart)], duration: [tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_calculateTimeDifferent, "f").call(this, cachedStart, cachedEnd)], dayMask: cachedDaymask });
        }
    }
    return linkRes;
};
tslib_1.__decorate([
    (0, datamodel_core_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], IrrigationSequentialSchedule.prototype, "getHash", void 0);
